import * as React from "react";
import { JSX } from "react/jsx-runtime";
const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={25}
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.2662 5.22614L16.1587 0.209808C16.0217 0.0753403 15.8375 0 15.6454 0H2.73285C1.22604 0 0 1.22585 0 2.73285V22.2672C0 23.774 1.22585 25 2.73285 25H18.7525C20.2593 25 21.4853 23.7741 21.4853 22.2672V5.74875C21.4853 5.5521 21.4064 5.36385 21.2662 5.22614ZM16.3778 2.47841L18.9619 5.01633H16.6107C16.4824 5.01633 16.3778 4.9118 16.3778 4.78344V2.47841ZM18.7525 23.5352H2.73285C2.03381 23.5352 1.46484 22.9664 1.46484 22.2672V2.73285C1.46484 2.03362 2.03362 1.46484 2.73285 1.46484H14.9132V4.78344C14.9132 5.71957 15.6748 6.48117 16.6109 6.48117H20.0205V22.2672C20.0205 22.9664 19.4517 23.5352 18.7525 23.5352Z"
      fill="#4682B4"
    />
    <path
      d="M15.8289 11.6211H5.50403C5.09948 11.6211 4.77161 11.949 4.77161 12.3535C4.77161 12.7581 5.09948 13.0859 5.50403 13.0859H15.8289C16.2334 13.0859 16.5613 12.7581 16.5613 12.3535C16.5613 11.949 16.2334 11.6211 15.8289 11.6211Z"
      fill="#4682B4"
    />
    <path
      d="M5.50403 16.0156H13.9227C14.3272 16.0156 14.6551 15.6878 14.6551 15.2832C14.6551 14.8787 14.3272 14.5508 13.9227 14.5508H5.50403C5.09948 14.5508 4.77161 14.8787 4.77161 15.2832C4.77161 15.6878 5.09948 16.0156 5.50403 16.0156Z"
      fill="#4682B4"
    />
    <path
      d="M14.9383 17.4805H5.50403C5.09948 17.4805 4.77161 17.8083 4.77161 18.2129C4.77161 18.6174 5.09948 18.9453 5.50403 18.9453H14.9383C15.3427 18.9453 15.6708 18.6174 15.6708 18.2129C15.6708 17.8083 15.3427 17.4805 14.9383 17.4805Z"
      fill="#4682B4"
    />
  </svg>
);
export default SVGComponent;
